import {
  Box,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
const PackagesTable = () => {
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    fetch("/json/packages/packages.json")
      .then((res) => res.json())
      .then((data) => {
        setPackages(data);
        setIsLoading(false);
      });
  }, []);
  return (
    <Box sx={{ px: 4 }}>
      {isLoading ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 400 }}>
            <TableBody>
              <TableRow
                sx={{
                  bgcolor: "primary.main",
                  verticalAlign: isMobile ? "bottom" : "center",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">
                    Primary{isMobile ? <br /> : " "}Packages
                  </Typography>
                </TableCell>
                <TableCell
                  align="left"
                  component="th"
                  scope="row"
                  sx={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography variant="h3">Channels</Typography>
                </TableCell>
                <TableCell
                  align="left"
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">Description</Typography>
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">Price</Typography>
                </TableCell>
              </TableRow>
              {packages?.slice(0, 4).map(
                (item) =>
                  item?.active && (
                    <TableRow key={item.id}>
                      <TableCell sx={{ verticalAlign: "top" }}>
                        <Typography variant="h6">{item.title}</Typography>
                      </TableCell>
                      <TableCell sx={{ verticalAlign: "top" }}>
                        <Typography sx={{ textAlign: "center" }} variant="h6">
                          {item.channels}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ verticalAlign: "top", maxWidth: 800 }}>
                        <Typography
                          sx={{ whiteSpace: "pre-line" }}
                          variant="body2"
                        >
                          {item.description}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          verticalAlign: "top",
                          marginLeft: "auto",
                          position: "relative",
                        }}
                        align="right"
                      >
                        <Stack
                          sx={{ mb: item.label ? 2 : 0 }}
                          direction="row"
                          justifyContent="flex-end"
                          gap={0}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 30, sm: 42, md: 48 },
                              whiteSpace: "pre",
                            }}
                            variant="h2"
                          >
                            ${""}
                            {item.price.split(".")[0].length < 3
                              ? `\u00A0 ${item.price.split(".")[0]}`
                              : item.price.split(".")[0]}
                          </Typography>
                          <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="flex-start"
                            gap={0}
                          >
                            <Typography
                              sx={{
                                fontSize: { xs: 16, sm: 18, md: 20 },
                                m: 0,
                                p: 0,
                                whiteSpace: "nowrap",
                              }}
                              variant="span"
                            >
                              {"."}
                              {item.price.split(".")[1]}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                m: 0,
                                mt: { xs: -1.5, sm: -1, md: -2 },
                              }}
                              variant="span"
                            >
                              /mo
                            </Typography>
                          </Stack>
                        </Stack>
                        {item.label && (
                          <Typography
                            sx={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              left: "20px",
                              margin: "auto",
                              bgcolor: "secondary.main",
                              textAlign: "center",
                              fontSize: { xs: 14, sm: 16, md: 18 },
                              borderRadius: 1,
                            }}
                            variant="span"
                          >
                            {item.label}
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  )
              )}

              <TableRow>
                <TableCell
                  colSpan={4}
                  sx={{ backgroundColor: "#25262C" }}
                ></TableCell>
              </TableRow>

              <TableRow
                sx={{
                  bgcolor: "primary.main",
                  verticalAlign: isMobile ? "bottom" : "center",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">
                    Add-on{isMobile ? <br /> : " "}Packages
                  </Typography>
                </TableCell>
                <TableCell
                  align="left"
                  component="th"
                  scope="row"
                  sx={{
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Typography variant="h3">Channels</Typography>
                </TableCell>
                <TableCell
                  align="left"
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">Description</Typography>
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Typography variant="h3">Price</Typography>
                </TableCell>
              </TableRow>
              {packages?.slice(4).map(
                (item) =>
                  item?.active && (
                    <TableRow key={item.id}>
                      <TableCell sx={{ verticalAlign: "top" }}>
                        <Typography variant="h6">{item.title}</Typography>
                      </TableCell>
                      <TableCell sx={{ verticalAlign: "top" }}>
                        <Typography sx={{ textAlign: "center" }} variant="h6">
                          {item.channels}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ verticalAlign: "top", maxWidth: 800 }}>
                        <Typography
                          sx={{ whiteSpace: "pre-line" }}
                          variant="body2"
                        >
                          {item.description}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          verticalAlign: "top",
                          marginLeft: "auto",
                          position: "relative",
                        }}
                        align="right"
                      >
                        <Stack
                          sx={{ mb: item.label ? 2 : 0 }}
                          direction="row"
                          justifyContent="flex-end"
                          gap={0}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: 30, sm: 42, md: 48 },
                              whiteSpace: "pre",
                            }}
                            variant="h2"
                          >
                            ${""}
                            {item.price.split(".")[0].length < 2 ? (
                              `\u00A0\u00A0\u00A0 ${item.price.split(".")[0]}`
                            ) : (
                              <>
                                {item.price.split(".")[0].length < 3
                                  ? `\u00A0 ${item.price.split(".")[0]}`
                                  : item.price.split(".")[0]}
                              </>
                            )}
                          </Typography>
                          <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="flex-start"
                            gap={0}
                          >
                            <Typography
                              sx={{
                                fontSize: { xs: 16, sm: 18, md: 20 },
                                m: 0,
                                p: 0,
                                whiteSpace: "nowrap",
                              }}
                              variant="span"
                            >
                              {"."}
                              {item.price.split(".")[1]}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                m: 0,
                                mt: { xs: -1.5, sm: -1, md: -2 },
                              }}
                              variant="span"
                            >
                              /mo
                            </Typography>
                          </Stack>
                        </Stack>
                        {item.label && (
                          <Typography
                            sx={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              left: "20px",
                              margin: "auto",
                              bgcolor: "secondary.main",
                              textAlign: "center",
                              fontSize: { xs: 14, sm: 16, md: 18 },
                              borderRadius: 1,
                            }}
                            variant="span"
                          >
                            {item.label}
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default PackagesTable;
